// @ts-nocheck

/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { CreateInviteCreateInviteGetQueryResponse } from "../models/undefinedController/CreateInviteCreateInviteGet.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@kubb/plugin-client/clients/axios";
import type { QueryKey, QueryClient, UseQueryOptions, UseQueryReturnType } from "@tanstack/vue-query";
import { createInviteCreateInviteGet } from "../client/createInviteCreateInviteGet.ts";
import { queryOptions, useQuery } from "@tanstack/vue-query";
import { toValue } from "vue";

export const createInviteCreateInviteGetQueryKey = () => [{ url: '/create_invite' }] as const

export type CreateInviteCreateInviteGetQueryKey = ReturnType<typeof createInviteCreateInviteGetQueryKey>

export function createInviteCreateInviteGetQueryOptions(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = createInviteCreateInviteGetQueryKey()
        return queryOptions<CreateInviteCreateInviteGetQueryResponse, ResponseErrorConfig<Error>, CreateInviteCreateInviteGetQueryResponse, typeof queryKey>({
        
        queryKey,
        queryFn: async ({ signal }) => {
            return createInviteCreateInviteGet({ ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Create Invite
 * {@link /create_invite}
 */
export function useCreateInviteCreateInviteGet<TData = CreateInviteCreateInviteGetQueryResponse, TQueryData = CreateInviteCreateInviteGetQueryResponse, TQueryKey extends QueryKey = CreateInviteCreateInviteGetQueryKey>(options: 
{
  query?: Partial<UseQueryOptions<CreateInviteCreateInviteGetQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = (resolvedOptions && 'queryKey' in resolvedOptions ? toValue(resolvedOptions.queryKey) : undefined) ?? createInviteCreateInviteGetQueryKey()

         const query = useQuery({
          ...createInviteCreateInviteGetQueryOptions(config),
          ...resolvedOptions,
          queryKey
         } as unknown as UseQueryOptions<CreateInviteCreateInviteGetQueryResponse, ResponseErrorConfig<Error>, TData, CreateInviteCreateInviteGetQueryResponse, TQueryKey>, toValue(queryClient)) as UseQueryReturnType<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}